"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketState = void 0;
var BasketState;
(function (BasketState) {
    BasketState["Full"] = "full";
    BasketState["TooLate"] = "too_late";
    BasketState["NotAvailable"] = "not_available";
    BasketState["LinkedOrder"] = "linked_order";
    BasketState["NonEditableOrder"] = "n_editable_active_order";
    BasketState["DifferentDeliveryDay"] = "editable_order_different_delivery_day";
    BasketState["Ok"] = "ok";
})(BasketState || (exports.BasketState = BasketState = {}));
exports.default = { BasketState: BasketState };
//# sourceMappingURL=Basket.js.map